import {
  // createAction,
  handleActions
} from "redux-actions";
import { FETCH_CURRENT_USER_SUCCESS, SEARCH_CLIENTS_SUCCESS, SHOW_TABLE, TABLE_LOADING } from "../sagas/clientProfileSearch/clientProfileSearch";
// Name Spaced Action Types
export const actions = {
  FETCH_CURRENT_USER_SUCCESS,
  SEARCH_CLIENTS_SUCCESS,
  SHOW_TABLE,
  TABLE_LOADING
};

export const initialState = {
  currentUser: {},
  searchResults: {
    tableInfo: {}
 },
  showTable: false,
  tableLoading: true
};

export default handleActions(
  {
    [FETCH_CURRENT_USER_SUCCESS]: (state, action) => ({
      ...state,
      currentUser: action.payload || state.currentUser
    }),
    [SHOW_TABLE]: state => ({
      ...state,
      showTable: true
    }),
    [TABLE_LOADING]: state => ({
      ...state,
      tableLoading: true
    }),
    [SEARCH_CLIENTS_SUCCESS]: (state, action) => ({
      ...state,
      searchResults: action.payload.data || state.searchResults,
      tableLoading: false
    })
  },
  initialState
);
